import { render, staticRenderFns } from "./yexiangtwo.vue?vue&type=template&id=c2d8ec88&scoped=true"
import script from "./yexiangtwo.vue?vue&type=script&lang=js"
export * from "./yexiangtwo.vue?vue&type=script&lang=js"
import style0 from "./yexiangtwo.vue?vue&type=style&index=0&id=c2d8ec88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d8ec88",
  null
  
)

export default component.exports